import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBreakpointsContext } from "@air/provider-media-query";
import { ContentCollectionCompletedUploads } from "./ContentCollectionCompletedUploads";
import { ContentCollectionCompletedUploadsButton } from "./ContentCollectionCompletedUploadsButton";
import { ContentCollectionSidebarHeader } from "./ContentCollectionSidebarHeader";
import { ContentCollectionSidebarSeparator } from "./ContentCollectionSidebarSeparator";
export const ContentCollectionCompletedSidebar = ()=>{
    const { isAboveMediumScreen } = useBreakpointsContext();
    return /*#__PURE__*/ _jsx("div", {
        className: "flex size-full shrink-0 items-end justify-stretch p-2 md:w-[372px] md:items-start",
        children: /*#__PURE__*/ _jsx("aside", {
            className: "flex w-full flex-col rounded-lg border border-grey-5 bg-grey-1 md:h-full md:overflow-y-auto",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex grow flex-col gap-6 px-4 py-6",
                children: [
                    isAboveMediumScreen && /*#__PURE__*/ _jsx(ContentCollectionSidebarHeader, {}),
                    /*#__PURE__*/ _jsx(ContentCollectionSidebarSeparator, {
                        className: "hidden md:block"
                    }),
                    /*#__PURE__*/ _jsx(ContentCollectionCompletedUploads, {}),
                    !isAboveMediumScreen && /*#__PURE__*/ _jsx(ContentCollectionCompletedUploadsButton, {})
                ]
            })
        })
    });
};
